module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-300.806854d4.ttf";